import '../../css/types/text-stub.css';

export const TextStub = {
	name: 'ui-image-stack-steps-text-skeleton',
	template: `
		<div class="ui-image-stack-steps-text-skeleton-area">
			<div class="ui-image-stack-steps-text-skeleton-area-stub"></div>
		</div>
	`,
};
